/** Parses lifecycle responses, including non-2xx configuration states, without caching transport failures. */
import type { TestFeedConnectionStatus } from '../types'
import {
  isTestFeedConnectionStatus,
  normalizeTestFeedConnectionStatus,
} from '../../src/shared/testfeed-connection-status-contract'

export async function readTestFeedConnectionStatus(response: Response): Promise<TestFeedConnectionStatus> {
  try {
    const payload = (await response.json()) as unknown
    if (isTestFeedConnectionStatus(payload)) {
      const status = normalizeTestFeedConnectionStatus(payload)
      if (status.code !== 'TESTFEED_CONNECTION_STATUS_UNAVAILABLE') return status
    }
  } catch (error) {
    console.error(error)
    throw new Error(`TestFeed connection status response was invalid (${response.status})`, { cause: error })
  }
  throw new Error(`TestFeed connection status response was invalid (${response.status})`)
}
